<div
  class="mbs-tile"
  [ngClass]="getTileClasses()"
  (click)="handleClick($event)">
  <ng-container
    [ngTemplateOutlet]="tileTemplate ? tileTemplate : defaultTile"
    [ngTemplateOutletContext]="{ $implicit: data }" />
</div>

<ng-template
  #defaultTile
  let-item>
  <header class="mbs-tile_header">
    <div class="form-row mbs-tile_header-row">
      <ng-container
        [ngTemplateOutlet]="headerTemplate ? headerTemplate : tileHeaderDefault"
        [ngTemplateOutletContext]="{ $implicit: item }" />
    </div>
  </header>
  @if (showBody) {
    <div class="mbs-tile_body">
      <div class="mbs-tile_data">
        @for (header of headers; track header?.id ?? header) {
          <div class="form-row mbs-tile_data-row">
            <div class="col-6 text-muted mbs-tile_data-option">{{ header.name }}:</div>
            <div
              class="col-6 mbs-tile_data-value"
              [class.text-overflow]="header.overflow">
              <ng-template
                #value
                [ngTemplateOutletContext]="{ $implicit: item, header: header }"
                [ngTemplateOutlet]="templates ? templates[header.id] : defaultValue" />
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template
  #defaultValue
  let-data
  let-header="header">
  {{ data[header.headerName] | json }}
</ng-template>

<ng-template #tileHeaderDefault>
  @if (icon; as icon) {
    <div class="mbs-tile_ico">
      <span [class]="icon"></span>
    </div>
  }
  <div
    class="mbs-tile_name"
    [ngbTooltip]="(hoverAble ? title : '') | titlecase">
    {{ title }}
  </div>
</ng-template>
